<template>
  <section id="tour_details_main" class="section_padding">
    <div class="container">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12">
        <div class="section_heading_center">
          <h2>{{ $t("terms_and_conditions_sl") }}</h2>
          <small>{{ $t('updated_last') }}: 15/10/2025</small>
        </div>
        
      </div>
      <div class="row text-center">
        <div class="col-lg-2"></div>
        <div class="col-lg-8">
          <div class="terms_service_content">
            <div class="terms_item" style="text-align: justify">
              <p>{{ $t("tc_introduction_1") }}</p>
              <p>{{ $t("tc_introduction_2") }}</p>
              <ol start="2">
                <li>
                  <p>
                    <strong>{{ $t("tc_legal_requirements_title") }}</strong>
                  </p>
                  <p>{{ $t("lr_1") }}</p>
                  <ul>
                    <li>{{ $t("ul_lr_1") }}</li>
                    <li>{{ $t("ul_lr_2") }}</li>
                    <li>{{ $t("ul_lr_3") }}</li>
                    <li>{{ $t("ul_lr_4") }}</li>
                  </ul>
                  <p>{{ $t("lr_2") }}</p>
                </li>
                <li>
                  <p>
                    <strong>{{ $t("tc_responsibilities_title") }}</strong>
                  </p>
                  <p>{{ $t("r_1") }}</p>
                  <ul>
                    <li>{{ $t("ul_r_1") }}</li>
                    <li>{{ $t("ul_r_2") }}</li>
                    <li>{{ $t("ul_r_3") }}</li>
                    <li>{{ $t("ul_r_4") }}</li>
                  </ul>
                  <p>{{ $t("r_2") }}</p>
                  <p>{{ $t("r_3") }}</p>
                  <p>{{ $t("r_4") }}</p>
                </li>
                <li>
                  <p>
                    <strong>{{ $t("tc_prohibited_content_title") }}</strong>
                  </p>
                  <p>{{ $t("pc_1") }}</p>
                  <ul>
                    <li>{{ $t("pc_ul_1") }}</li>
                    <li>{{ $t("pc_ul_2") }}</li>
                  </ul>
                  <p>{{ $t("pc_2") }}</p>
                </li>
                <li>
                  <p>
                    <strong>{{ $t("tc_payments_title") }}</strong>
                  </p>
                  <p>
                    <strong>{{ $t("tc_payments_b2c_title") }}</strong>
                  </p>
                  <p>{{ $t("tc_payments_b2c_p1") }}</p>
                  <p>{{ $t("tc_payments_b2c_p2") }}</p>
                  <p>{{ $t("tc_payments_b2c_p3") }}</p>
                  <ul>
                    <li>{{ $t("tc_payments_b2c_ul_1") }}</li>
                    <li>{{ $t("tc_payments_b2c_ul_2") }}</li>
                    <li>{{ $t("tc_payments_b2c_ul_3") }}</li>
                  </ul>
                  <p>{{ $t("tc_payments_b2c_p4") }}</p>
                  <p>
                    <strong>{{ $t("tc_payments_b2b_title") }}</strong>
                  </p>
                  <p>{{ $t("tc_payments_b2b_p1") }}</p>
                  <ul>
                    <li>{{ $t("tc_payments_b2b_ul_1") }}</li>
                    <li>{{ $t("tc_payments_b2b_ul_2") }}</li>
                  </ul>
                  <p>{{ $t("tc_payments_b2b_p2") }}</p>
                  <p>
                    <strong>{{ $t("tc_payments_hyperguest_title") }}</strong>
                  </p>
                  <p>{{ $t("tc_payments_hyperguest_p1") }}</p>
                  <p>
                    <strong>{{ $t("tc_payments_neutrality_title") }}</strong>
                  </p>
                  <p>{{ $t("tc_payments_neutrality_p1") }}</p>
                  <p>
                    <strong>{{ $t("tc_payments_dispersion_title") }}</strong>
                  </p>
                  <p>{{ $t("tc_payments_dispersion_p1") }}</p>
                  <p>{{ $t("tc_payments_dispersion_p2") }}</p>
                  <p>
                    <strong>{{ $t("tc_payments_fixed_fee_title") }}</strong>
                  </p>
                  <p>{{ $t("tc_payments_fixed_fee_p1") }}</p>
                  <p>{{ $t("tc_payments_fixed_fee_p2") }}</p>
                  <p>{{ $t("tc_payments_fixed_fee_p3") }}</p>
                  <p>{{ $t("tc_payments_fixed_fee_p4") }}</p>
                </li>
                  
                <li>
                  <p>
                    <strong>{{ $t("tc_data_handling_title") }}</strong>
                  </p>
                  <p>{{ $t("dh_1") }}</p>
                  <p>{{ $t("dh_2") }} {{ $t("dh_3") }}</p>
                </li>
                <li>
                  <p>
                    <strong>{{ $t("tc_admission_right_title") }}</strong>
                  </p>
                  <p>{{ $t("ar_1") }}</p>
                  <ul>
                    <li>{{ $t("ul_ar_1") }}</li>
                    <li>{{ $t("ul_ar_2") }}</li>
                    <li>{{ $t("ul_ar_3") }}</li>
                  </ul>
                </li>
                <li>
                  <p>
                    <strong>{{ $t("tc_amendments_title") }}</strong>
                  </p>
                  <p>{{ $t("a_1") }}</p>
                  <p>{{ $t("a_2") }}</p>
                </li>
                <li>
                  <p>
                    <strong>{{ $t("tc_law_disputes_title") }}</strong>
                  </p>
                  <p>{{ $t("ld_1") }}</p>
                </li>
                <li>
                  <p>
                    <strong>{{ $t("tc_admin_panel_title") }}</strong>
                  </p>
                  <p>{{ $t("ap_1") }}</p>
                  <ul>
                    <li>{{ $t("ul_ap_1") }}</li>
                    <li>{{ $t("ul_ap_2") }}</li>
                    <li>{{ $t("ul_ap_3") }}</li>
                  </ul>
                  <p>{{ $t("ap_2") }}</p>

                </li>
                <li>
                  <p>
                    <strong>{{ $t("tc_misconduct_title") }}</strong>
                  </p>
                  <p>{{ $t("tc_misconduct_p1") }}</p>
                  <p>{{ $t("tc_misconduct_p2") }}</p>
                  <p>{{ $t("tc_misconduct_p3") }}</p>
                  <p>{{ $t("tc_misconduct_p4") }}</p>
                  <p>{{ $t("tc_misconduct_p5") }}</p>
                </li>
                <li>
                  <p>
                    <strong>{{ $t("tc_contact_title") }}</strong>
                  </p>
                  <p>{{ $t("tc_contact_intro") }}</p>
                  <ul>
                    <li>
                      {{ $t("tc_contact_email_label") }} contacto@selahcomfort.com
                    </li>
                    <li>
                      {{ $t("tc_contact_phone_label") }} +57 310801 7473
                    </li>
                  </ul>
                </li>
              </ol>
            </div>
          </div>
        </div>
        <div class="col-lg-2"></div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "PrivacyPolicyContent",
};
</script>
<style scoped>
ul>li {
  list-style: outside;
  font-size: 16px;
  line-height: 28px;
  color: var(--paragraph-color);
  font-weight: 400;
  font-family: 'Poppins', sans-serif;
  margin-bottom: 0;
}

ul {
  padding-left: 30px;
}
</style>
